export default "/staticreactui/static/media/static/media/translator1.04cc22f1.png";